import { atom } from "jotai";
import { nodesAtom } from "./nodesAtom";
import { saveCanvasSetter } from "../persistence";

export const saveNodeOnResizeEndSetter = atom(
  null,
  (get, set, { id, width, height, x, y }) => {
    const nodes = get(nodesAtom);

    const updatedNodes = nodes.map((node) => {
      if (node.id === id) {
        return {
          ...node,
          width,
          height,
          position: { x, y },
        };
      }

      return node;
    });

    /** Don't need to update RF state for height & width since that's already happening */
    set(saveCanvasSetter, { nodes: updatedNodes });
  },
);

saveNodeOnResizeEndSetter.debugLabel = "saveNodeOnResizeEndSetter";
